module.exports = __webpack_public_path__ + "media/images/icon_nav_search-5662911fc8345b12d9041f559259a205.svg";